import { Controller } from "@hotwired/stimulus";

// Keeps the section nav highlight in sync when navigation happens inside the
// `page-content` Turbo Frame (the nav lives in the layout, outside the frame,
// so it is not re-rendered on frame visits). Recomputes the active item from
// the current URL on load and after each frame render.
export default class extends Controller {
  static targets = ["item"];
  static classes = ["active"];

  connect() {
    this.update = this.update.bind(this);
    this.update();
    document.addEventListener("turbo:load", this.update);
    document.addEventListener("turbo:frame-render", this.update);
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.update);
    document.removeEventListener("turbo:frame-render", this.update);
  }

  update() {
    // Defer a frame so the history/URL has settled after a frame visit that
    // advances the location, otherwise we'd read the previous pathname.
    requestAnimationFrame(() => {
      const section = this.currentSection();
      this.itemTargets.forEach((el) => {
        el.classList.toggle(this.activeClass, el.dataset.navSection === section);
      });
    });
  }

  currentSection() {
    const path = window.location.pathname;
    if (/^\/notes/.test(path)) return "notes";
    if (/^\/reminders/.test(path)) return "reminders";
    if (/^\/admin\/telegram_subscribers/.test(path)) return "telegram_subscribers";
    if (/^\/admin\/attachments/.test(path)) return "attachments";
    if (/^\/trash/.test(path)) return "trash";
    if (/^\/investments/.test(path)) return "investments";
    if (/^\/users/.test(path)) return "users";
    if (/^\/events/.test(path)) return "events";
    // The public reader is exactly /pirts_day; every deeper path is the corpus editor.
    if (/^\/pirts_day\/\w/.test(path)) return "pirts_day_details";
    if (/^\/pirts_day/.test(path)) return "pirts_day";
    return "";
  }
}
